/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonUserInfo,
    JsonUserInfoFromJSON,
    JsonUserInfoFromJSONTyped,
    JsonUserInfoToJSON,
} from './JsonUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonUserInfo
 */
export interface ApiResultOfJsonUserInfo {
    /**
     * 
     * @type {JsonUserInfo}
     * @memberof ApiResultOfJsonUserInfo
     */
    data?: JsonUserInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonUserInfo
     */
    result?: ApiResultOfJsonUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonUserInfoFromJSON(json: any): ApiResultOfJsonUserInfo {
    return ApiResultOfJsonUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonUserInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonUserInfoToJSON(value?: ApiResultOfJsonUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonUserInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

